import { graphql, useStaticQuery } from "gatsby"

const useGlobalTheme = () => {
  const data = useStaticQuery(graphql`
    query GlobalThemeQuery {
      theme: globals(handle: { eq: "theme" }) {
        custom_css {
          value
        }
        primary
        secondary
        background
        highDensity
        logo {
          localImage {
            childImageSharp {
              original {
                width
                height
                src
              }
            }
          }
        }
        logo_negative {
          localImage {
            childImageSharp {
              original {
                width
                height
                src
              }
            }
          }
        }
        defaultTeaserImage {
          localImage {
            childImageSharp {
              original {
                src
              }
            }
          }
        }
        metaImage {
          localImage {
            childImageSharp {
              original {
                src
              }
            }
          }
        }
        feature_search
        feature_cookie_banner
        mainFont {
          value
        }
      }
    }
  `)

  return data.theme || {}
}

export default useGlobalTheme
